module.exports = __webpack_public_path__ + "img/myneofintech_blanco.e37fb63a.png";